import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Import datepicker styles
import { FaTimes } from "react-icons/fa"; // Import a clear icon
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardHeader from "../../components/auth/DashboardHeader";
import Sidebar from "../../components/auth/Sidebar";
import { Loader } from "../../components/Loader";
import PaymentLinkTable from "../../components/TransactionsDataTable";
import API from "../../helper/AxiosInterceptor";
import { exportDepositHistoryToPDF } from "../../helper/helper";

const PaymentLinks = () => {
  const { appId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [depositHistory, setDepositHistory] = useState([]);
  const [appInfo, setAppInfo] = useState(null);

  const [startDate, setStartDate] = useState(null); // State for start date
  const [endDate, setEndDate] = useState(null); // State for end date

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchAppDetails = async () => {
      try {
        const response = await API.get(
          `${process.env.REACT_APP_API_URL}/apps/getById`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            params: {
              appId: appId,
            },
          }
        );
        console.log("response response", response);
        if (response?.data) {
          setAppInfo(response?.data?.data);
        }
      } catch (error) {
        console.error("Error fetching Mnemonic details:", error);
      }
    };
    fetchAppDetails();
  }, [appId]);

  async function getDepositHistory() {
    try {
      setIsLoading(true);
      const params = {
        pageNo: currentPage,
        limitVal: 15,
        appId: appId,
      };
      // Add date range filter if both startDate and endDate are selected
      if (startDate && endDate) {
        params.startDate = startDate;
        params.endDate = endDate;
      }
      const res = await API.get(
        `${process.env.REACT_APP_API_URL}/payment-link/merchant-tx-list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: params,
        }
      );

      console.log("Deposit history res : ", res);

      setDepositHistory(res.data);
      setCurrentPage(res?.data?.currentPage);
      setTotalPages(res?.data?.totalPages);
    } catch (err) {
      console.log("Error getting wallet history: ", err);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getDepositHistory(currentPage);
  }, [appInfo, currentPage]);

  // Handle date input change
  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  // Handle Search button click
  const handleSearchClick = () => {
    if (startDate && !endDate) {
      toast.error("Please select end date.");
      return;
    }
    if (!startDate && endDate) {
      toast.error("Please select start date.");
      return;
    }
    getDepositHistory(); // Fetch data with selected date range
  };

  // Clear selected dates
  const clearStartDate = () => {
    setStartDate(null);
    getDepositHistory(); // Fetch all data after clearing date
  };

  const clearEndDate = () => {
    setEndDate(null);
    getDepositHistory(); // Fetch all data after clearing date
  };

  //pagination
  const handlePageChange = (pageNo) => {
    if (pageNo > 0 && pageNo <= totalPages) {
      setCurrentPage(pageNo);
    }
  };

  console.log("depositHistory: ", depositHistory);
  console.log("appInfo : ", appInfo);

  return (
    <>
      <DashboardHeader appId={appInfo?._id} />
      <div className="site-bg">
        <div className="dashborad-content-bg">
          <aside className="sidebar">
            <Sidebar />
          </aside>
          <div className="dashborad-warper" style={{ position: "relative" }}>
            {isLoading && <Loader inline={true} />}
            <div className="transactions-list">
              <div className="dashborad-head">
                <div className="breadcrumb-menu">
                  <ul>
                    <li className="active">
                      <Link to="/apps">Apps &rarr; </Link>
                    </li>
                    <li className="active">
                      <Link to={`/apps-detail/${appId}`}>{appInfo?.name}</Link>
                    </li>
                    <li>
                      <a>&rarr; Payment Links</a>
                    </li>
                  </ul>
                </div>
                <div className="dashborad-head-right gap-2">
                  <div className="date-range-select d-flex gap-2">
                    <div className="position-relative">
                      <DatePicker
                        selected={startDate}
                        onChange={handleStartDateChange}
                        className="form-control"
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Start Date"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={new Date()}
                      />
                      {startDate && (
                        <FaTimes
                          className="clear-icon"
                          onClick={clearStartDate}
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#888",
                          }}
                        />
                      )}
                    </div>
                    <div className="position-relative">
                      <DatePicker
                        selected={endDate}
                        onChange={handleEndDateChange}
                        className="form-control"
                        dateFormat="yyyy-MM-dd"
                        placeholderText="End Date"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={new Date()}
                      />
                      {endDate && (
                        <FaTimes
                          className="clear-icon"
                          onClick={clearEndDate}
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#888",
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="view-balances-btn ml-2">
                    <a className="btn" onClick={handleSearchClick}>
                      Search
                    </a>
                    <a
                      className="btn"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#f8f9fa",
                      }}
                      onClick={() => {
                        exportDepositHistoryToPDF(depositHistory?.data);
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#D3D3D3")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "#f8f9fa")
                      }
                    >
                      Export All
                    </a>
                  </div>
                </div>
              </div>
              <div className="white-bg my-apps-content padd20">
                <PaymentLinkTable
                  transactions={depositHistory?.data}
                  isCode={true}
                  isReceivedAmount={true}
                  isAmount={true}
                />
                <div className="pagination-box">
                  <ul>
                    <li>
                      <a
                        href=""
                        // onClick={() => handlePageChange(currentPage - 1)}
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                        disabled={currentPage === 1}
                      >
                        <img src="images/left-arrow.png" alt="arrow" />
                      </a>
                    </li>
                    {[...Array(totalPages).keys()].map((pageNo) => (
                      <li
                        key={pageNo + 1}
                        className={currentPage === pageNo + 1 ? "active" : ""}
                      >
                        <a
                          href=""
                          // onClick={() => handlePageChange(pageNo + 1)}
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(pageNo + 1);
                          }}
                        >
                          {pageNo + 1}
                        </a>
                      </li>
                    ))}
                    <li>
                      <a
                        href=""
                        // onClick={() => handlePageChange(currentPage + 1)}
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                        disabled={currentPage === totalPages}
                      >
                        <img src="images/right-arrow.png" alt="arrow" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentLinks;
